/**
 * @description 判斷該連結或功能是否須先進行登入用
 */
export enum Premission {
  LoginRequired = '1'
}
